import { colors } from '../../styles/tokens'
import { TextPill } from './TextPill'

/**
 * Compact pill indicating that a contact is on the Do Not Contact list.
 * Use inline next to contact names or in a dedicated table cell.
 */
export function DoNotContactPill({ label = 'DNC' }: { label?: string }) {
  return (
    <TextPill
      style={{ marginBottom: 0 }}
      backgroundColor={colors['status-rejected-bg']}
      textColor={colors['status-rejected-text']}
    >
      {label}
    </TextPill>
  )
}
